module.exports = __webpack_public_path__ + "img/Megaro-Konkat.6e35541b.jpg";